import { doBoxesIntersect, getElementBounds } from "../geometry/elementBounds";
import { getVisibleSceneRect } from "../geometry/viewportTransform";
import { drawCanvasElement } from "./drawElement";
import { drawCanvasDotGrid } from "./drawGrid";

const CULL_MARGIN = 48;

/**
 * @param {{ ctx: CanvasRenderingContext2D, dpr: number, size: { width: number, height: number } }} params
 * @returns {void}
 */
export const clearCanvas = ({ ctx, dpr, size }) => {
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  ctx.clearRect(0, 0, size.width, size.height);
};

/**
 * @param {{ ctx: CanvasRenderingContext2D, dpr: number, viewport: { x: number, y: number, zoom: number } }} params
 * @returns {void}
 */
export const applySceneTransform = ({ ctx, dpr, viewport }) => {
  ctx.setTransform(
    dpr * viewport.zoom,
    0,
    0,
    dpr * viewport.zoom,
    dpr * viewport.x,
    dpr * viewport.y
  );
};

/**
 * Static layer: committed elements only. Redraws happen on commits and
 * viewport changes — never during draw/select gestures. Elements currently
 * "lifted" into the overlay (mid move/resize) are skipped, and off-screen
 * elements are culled.
 * @param {{ canvas: HTMLCanvasElement | null, dpr: number, engineState: object, getImage: Function, palette?: object }} params
 * @returns {void}
 */
export const drawStaticScene = ({ canvas, dpr, engineState, getImage, palette }) => {
  const ctx = canvas?.getContext("2d");
  if (!ctx) return;
  const { editingText, elements, liftedElements, size, viewport } = engineState;

  clearCanvas({ ctx, dpr, size });
  applySceneTransform({ ctx, dpr, viewport });
  drawCanvasDotGrid({ ctx, palette, size, viewport });
  const visibleRect = getVisibleSceneRect({
    margin: CULL_MARGIN,
    size,
    viewport,
  });

  elements.forEach((element) => {
    if (liftedElements?.has(element.id)) return;
    if (!doBoxesIntersect(getElementBounds(element), visibleRect)) return;
    drawCanvasElement({
      ctx,
      element,
      getImage,
      isTextEditing: element.id === editingText?.elementId,
      palette,
    });
  });
};
